module.exports = __webpack_public_path__ + "img/c3-tit.a673222a.png";